/* eslint-disable */
import * as util from "@/api/contact";

const state = {
    contactListArr: [],
    groupListArr: [],
    formParamGroupSt: {
        id: "",
        name: "",
        description: "",
    },
    isShowForm: false,

};

const mutations = {
    SET_isShowForm: (state, value) => {
        state.isShowForm = value
    },
    SET_formParamGroupSt: (state, value) => {
        state.formParamGroupSt = value
    },
    SET_contactListArr: (state, value) => {
        state.contactListArr = value
    },
    SET_groupListArr: (state, value) => {
        state.groupListArr = value
    }
};

const actions = {
    detailGroup({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.detailGroup(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    actFormParamGroupSt({ commit }, data) {
        commit("SET_formParamGroupSt", data);
    },
    setIsShowForm({ commit }, data) {
        commit("SET_isShowForm", data);
    },
    countContactByGroupId({ commit }, groupId) {
        return new Promise((resolve, reject) => {
            util.countContactByGroupId(groupId).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getContactIdByGroup({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getContactIdByGroup(dataParams).then(response => {
                resolve(response);
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getContactIdByPhone({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getContactIdByPhone(dataParams).then(response => {
                resolve(response);
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    deleteGroupSelected({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.deleteGroupSelected(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    removeGroup({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.removeGroup(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    exportData({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.exportData(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    splitContactGroup({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.splitContactGroup(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    unassignGroup({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.unassignGroup(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    unassignContactSelected({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.unassignContactSelected(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    addContactToList({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.addContactToList(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    removeAllContact() {
        return new Promise((resolve, reject) => {
            util.removeAllContact().then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteContactSelected({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.deleteContactSelected(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    syncContactsCheck({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.syncContactsCheck(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    syncContactsProcess({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.syncContactsProcess(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    updateGroup({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.updateGroup(dataParams).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createGroup({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.createGroup(dataParams).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    importContact({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.importContact(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setContactListArr({ commit }, data) {
        commit("SET_contactListArr", data);
    },
    setGroupListArr({ commit }, data) {
        commit("SET_groupListArr", data);
    },
    createContact({ }, dataParams) {
        return new Promise((resolve, reject) => {
            util.createContact(dataParams).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateContact({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.updateContact(dataParams).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    viewContact({ commit }, id) {
        return new Promise((resolve, reject) => {
            util.viewContact(id).then(response => {
                const { data } = response;
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getGroupListV2({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getGroupList(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getTagList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getTagList(dataParams).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getGroupList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getGroupList(dataParams).then(response => {
                const { data } = response;
                commit("SET_groupListArr", data.data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getContactListFromTags({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getContactListFromTags(dataParams).then(response => {
                const { data } = response;
                // commit("SET_contactListArr", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getContactList({ commit }, dataParams) {
        return new Promise((resolve, reject) => {
            util.getContactList(dataParams).then(response => {
                const { data } = response;
                // commit("SET_contactListArr", data);
                resolve(data);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/contact.js